import axiosConfig from '@/configs/index.js'
import axios from "axios"
import store from "@/store"
import createComponent from "#/createComponent.js";
import Login from "#/common_components/Login.vue";
import router from "@/router";

//
import {
    getQueryVariable,
    getAxiosQueryVariable,
} from "#/utils/url.js"

//
var hostConfigMap = axiosConfig.axios;

//
class Axios {
    constructor(host) {
        this.host = host;
        //
        this.http = axios.create({
            baseURL: host,
            withCredentials: true,
        })

        //
        this.http.interceptors.request.use(
            request => {
                request.headers.Authorization = store.state.auth.token || "";
                
                //
                console.log("request.headers.Authorization: ", request.headers.Authorization);

                //
                return request;
            },
            error => {
                //
                console.error(error.message);

                //
                return Promise.reject(error);
            },
        );

        this.http.interceptors.response.use(
            response => {
                //
                const token = response.headers["Authorization"] || response.headers["authorization"];
                
                //
                if (token) {
                    store.commit("auth/setToken", token);
                }

                //
                switch (response.data.statusCode) {
                    case "401": // 未登录
                    case "900":
                        {
                            if(getQueryVariable("independent") == 1)
                            {
                                return response;
                            }
                            //
                            if (getAxiosQueryVariable(response.config.url, "goToLoginPage") == 1)
                            {
                                // need go to login page, delete all popup login frame and popup couponIndicator
                                if(document.getElementById("loginPopup"))
                                {
                                    document.getElementById("loginPopup").remove();
                                }
                                if (document.getElementById("popUpCouponIndicator")) {
                                    document.getElementById("popUpCouponIndicator").remove();
                                }

                                //
                                const fromUrl = getAxiosQueryVariable(response.config.url, "fromUrl");
                                if (fromUrl && fromUrl.length > 0)
                                {
                                    router.replace(`/login?independent=1&fromUrl=${fromUrl}`)
                                }
                                else
                                {
                                    router.replace("/login?independent=1")
                                }
                            }
                            else
                            {
                                // popup mode, and current path is not login
                                if (document.getElementById("loginPopup") == null && 
                                    window.location.href.substring(window.location.href.length - '#/login'.length) != '#/login' &&
                                    window.location.href.indexOf('#/login?') < 0) {
                                    createComponent(Login, {
                                        on: {
                                            loginSuccess() {
                                                window.location.reload();
                                            },
                                        },
                                    });
                                }
                            }
                        }
                    default: {
                        return response;
                    }
                }
            },
            error => {
                //
                console.error("response error: ", error.message);

                //
                return Promise.reject(error);
            },
        );
    }

    async apiAxios(method, url, params, _headers) {
        //
        let headers = {

        }

        //
        if (_headers)
        {
            headers = _headers;
        }

        if (method === 'POST' || method === 'PUT') {
            headers = Object.assign(headers, {
                'Content-Type': 'application/json;charset=utf-8',
            });
        }
        else {
            headers = Object.assign(headers, {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            });
        }

        //
        const res = await this.http({
            method: method,
            url: url,
            headers: headers,
            data: method === 'POST' || method === 'PUT' ? params : null,
            params: method === 'GET' || method === 'DELETE' ? params : null
        });

        if (res.status < 200 || res.status >= 300) {
            await Promise.reject('invalid status code');
        }

        //
        return res.data;
    }

    async get(url, params, headers) {
        return this.apiAxios('GET', url, params, headers)
    }

    async post(url, params, headers) {
        return this.apiAxios('POST', url, params, headers)
    }

    async put(url, params, headers) {
        return this.apiAxios('PUT', url, params, headers)
    }

    async delete(url, params, headers) {
        return this.apiAxios('DELETE', url, params, headers)
    }
}


//
const axiosInstance = {};
for (let name in hostConfigMap) {
    //
    const config = hostConfigMap[name];

    //
    axiosInstance[name] = new Axios(config.host)
}

//
export default axiosInstance
